<h6 *ngIf="label && !label_inline" class="tm-toggle-label" [ngClass]="{'req':mandatory,'read-only':disabled}">
  {{label | translate}}</h6>
<ul class="tg-list">
  <!-- <li class="tg-list-item">
    <h4>Light</h4>
    <input class="tgl tgl-light" id="cb1" type="checkbox" />
    <label class="tgl-btn" for="cb1"></label>
  </li> -->

  <li class="tg-list-item">
    <mat-label *ngIf="label_inline" class="col-form-label d-inline-block   mr-2 "
      [ngClass]="{'req':mandatory,'read-only':disabled}">
      {{label |translate}}
    </mat-label>

    <input class="tgl tgl-ios" [id]="random_id" type="checkbox" [(ngModel)]="checkbox" #tm_toogle [readonly]="disabled"
      [disabled]="disabled?true:false" (change)="toggleButton(tm_toogle.checked)" />
    <label style="display: inline-block;" class="tgl-btn  mb-0" [ngClass]="extra_class"
      [title]="data?(active_label | translate) : (inactive_label | translate)" [for]="random_id"></label>
  </li>
  <!-- <li class="tg-list-item">
    <h4>Skewed</h4>
    <input class="tgl tgl-skewed" id="cb3" type="checkbox" />
    <label class="tgl-btn" data-tg-off="OFF" data-tg-on="ON" for="cb3"></label>
  </li>
  <li class="tg-list-item">
    <h4>Flat</h4>
    <input class="tgl tgl-flat" id="cb4" type="checkbox" />
    <label class="tgl-btn" for="cb4"></label>
  </li>
  <li class="tg-list-item">
    <h4>Flip</h4>
    <input class="tgl tgl-flip" id="cb5" type="checkbox" />
    <label class="tgl-btn" data-tg-off="Nope" data-tg-on="Yeah!" for="cb5"></label>
  </li> -->
</ul>